<template>
  <v-container>
    <nice-data
      :data="device"
      langPrefix="device."
      :textColor="$vuetify.theme.defaults.dark.accent"
      :ignore="['deviceMetas']"
    />

    <!-- TODO: add ability to add meta data here  -->
    <device-meta-form :deviceId="$route.params.id" />
    <br />
    <v-container>
      <v-btn
        router
        :to="`/device/fields/create/${$route.params.id}`"
        block
        color="accent"
        >{{ $t("device.fields.addSensorField") }}</v-btn
      >
    </v-container>

    <nice-data-table
      v-if="fields != undefined"
      :data="fields"
      languagePrefix="device.fields."
      :loading="false"
      :title="$t('device.fields.dataTableTitle')"
      :ignore="['value', 'device']"
      :actions="true"
    >
      <template v-slot:[`item.ignore`]="{ item }">
        <v-switch v-model="item.ignore" @change="switchIgnore(item)">{{
          item.ignore
        }}</v-switch>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon color="primary" @click="clickedRow(item)">mdi-pen</v-icon>
      </template>
    </nice-data-table>
    <br />
    <v-row class="justify-end">
      <v-col class="justify-start align-center d-flex pt-0">
        <h2 class="pl-2">
          {{ `${$t("common.latest")} ${$t("common.values")}` }}
        </h2>
      </v-col>
      <v-col class="justify-end align-center d-flex pt-0">
        <span class="px-2">
          {{ $t("common.amount") }}
        </span>
        <v-select
          style="max-width: 7vh"
          v-model="limit"
          :items="limits"
          outlined
          dense
          hide-details
        >
        </v-select>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row v-for="(item, index) in deviceData" v-bind:key="index">
      <v-col sm="12" md="12" style="padding: 0">
        <h4>{{ humanDate(item.createdAt) }}</h4>
        <vue-json-pretty
          style="margin: 1rem; text-align: left"
          :deep="0"
          :data="item.json"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { format } from "date-fns";
import DeviceMetaForm from "@/components/device/DeviceMetaForm";

export default {
  name: "DeviceDetails",
  data() {
    return {
      limit: 5,

      limits: [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "20", value: 20 },
        { text: "50", value: 50 },
      ],
    };
  },

  computed: {
    ...mapState("devices", { device: "device" }),
    ...mapState("deviceFields", { status: "status", fields: "fields" }),
    ...mapState("deviceDatas", { deviceData: "datas" }),
  },

  methods: {
    ...mapActions("devices", { getDevice: "getById" }),
    ...mapActions("deviceFields", {
      getFieldsFromDevice: "getFieldsForDevice",
      updateField: "update",
    }),
    ...mapActions("deviceDatas", { getData: "getByDevice" }),

    humanDate(date) {
      return date !== undefined && date !== null
        ? format(new Date(date), "dd/MMM - HH:mm")
        : "N/A";
    },

    clickedRow(item) {
      if (this.allowed(null, this.Roles.CompanyOrUser))
        this.$router.push(`/device/fields/update/${item.deviceFieldId}`);
    },

    async switchIgnore(item) {
      await this.updateField({
        deviceFieldId: item.deviceFieldId,
        payload: item,
      });
    },

    async updateData() {
      let queryId = this.$route.params.id;
      if (queryId == undefined) {
        this.$router.push("/device");
      }

      await this.getDevice(queryId);
      await this.getFieldsFromDevice(queryId);
      await this.getData({ deviceId: queryId, limit: this.limit });

      for (let d in this.deviceData) {
        this.deviceData[d].json = JSON.parse(this.deviceData[d].json);
        console.log(this.deviceData[d].json);
      }
    },
  },

  async created() {
    await this.updateData();
  },

  watch: {
    async limit(v) {
      console.log("limit changed", v);
      await this.updateData();
    },
  },
  components: {
    DeviceMetaForm,
  },
};
</script>
